import { inject } from '@angular/core';
import { ActivatedRouteSnapshot } from '@angular/router';

import { RoutePathEnum } from '@connect-services/client/models/routes.model';
import { FilterTypeEnum } from '@connect-services/client/services/filter.service';
import { FilterResolverService } from '@connect-services/client/services/filter-resolver.service';

type Services = {
    filterResolverService: FilterResolverService;
};

export function filterResolver(route: ActivatedRouteSnapshot): void {
    // Injections must be declared here to avoid Angular error: NG0203 about injection context
    const services: Services = {
        filterResolverService: inject(FilterResolverService),
    };

    inspectRoute(route, services);
}

function inspectRoute(route: ActivatedRouteSnapshot, services: Services): void {
    const label: RoutePathEnum = (route.routeConfig?.data?.['name'] ?? '') as RoutePathEnum;

    loadFilter(label, route, services);

    if (!route.firstChild) {
        return;
    }
    inspectRoute(route.firstChild, services);
}

function loadFilter(routeLabel: RoutePathEnum, route: ActivatedRouteSnapshot, services: Services): void {
    const splitRouteLabel = routeLabel.split(':').at(-1);

    switch (splitRouteLabel) {
        case RoutePathEnum.FIELD_INTERVENTION_DASHBOARD:
            services.filterResolverService.currentFilterType.set(null);
            break;
        case RoutePathEnum.FIELD_INTERVENTION_ID:
        case RoutePathEnum.FIELD_INTERVENTION_PLANNING:
            services.filterResolverService.currentFilterType.set(FilterTypeEnum.FIELD_INTERVENTION_ENTITIES);
            break;
        case RoutePathEnum.FIELD_INTERVENTION_ENTITIES:
            services.filterResolverService.currentFilterType.set(FilterTypeEnum.FIELD_INTERVENTION_ENTITIES);
            break;
        case RoutePathEnum.PROJECT_ID:
            services.filterResolverService.currentFilterType.set(FilterTypeEnum.MAP_ENTITIES);
    }
}
